const role = '/business/jgRole/'
const dept = '/business/jgDept/'
const person = '/business/jgUser/'
const project = '/business/jgProject/'
const dic = '/business/jgDic/'
const field = '/business/yhSupplier/'
const api = {
  // 用户
  userInfo: '/business/iparkUser/selectIparkUserByUserId',
  updateInitPassword: '/business/iparkUser/updateInitPassword',
  // 角色
  getRoleList: role + 'selectJgRoleByList',
  rolePage: role + 'selectJgRoleByPage',
  roleAdd: role + 'insertJgRole',
  roleUpdate: role + 'updateJgRole',
  roleDelete: role + 'deleteJgRole',
  roleDetail: role + 'selectJgRoleById',
  roleMenu: role + 'selectJgMenuById',
  roleAppMenu: role + 'selectAppJgMenuById',
  // 组织架构
  departmentList: dept + 'selectJgDeptByList',
  departmentAdd: dept + 'insertJgDept',
  departmentUpdate: dept + 'updateJgDept',
  departmentDelete: dept + 'deleteJgDept',
  // 人员
  personnelPage: person + 'selectJgUserByPage',
  personnelAdd: person + 'insertJgUser',
  personnelUpdate: person + 'updateJgUser',
  personnelDetail: person + 'selectJgUserByUserId',
  personnelDisabled: person + 'deleteJgUser',
  personnelDelete: person + 'eliminateJgUser',
  resetPassword: person + 'resetPassword',
  insertJGhProjectByUserId: project + 'insertJgProjectByUserId',
  getRoleUserList: person + '/selectJgUserByList',
  // 操作日志
  selectYhLogByPage: '/msg/YhLog/selectYhLogByPage',
  // 数据字典
  selectDicByList: dic + 'selectDicByList',
  selectDicByPage: dic + 'selectDicByPage',
  selectDicTypeByList: dic + 'selectDicTypeByList',
  insertDic: dic + 'insertDic',
  updateDic: dic + 'updateDic',
  selectDicByDicId: dic + 'selectDicByDicId',
  // 菜单管理
  getMenu: '/business/jgMenu/selectJgMenuByList',
  // 供应商管理
  insertYhSupplier: field + 'insertYhSupplier',
  updateYhSupplier: field + 'updateYhSupplier',
  deleteYhSupplier: field + 'deleteYhSupplier',
  selectYhSupplierBySupplierId: field + 'selectYhSupplierBySupplierId',
  selectYhSupplierByPage: field + 'selectYhSupplierByPage'
}
export default api
